const AlertsMaintenanceHistoryComponent = {
  template: require("./alerts-maintenance-history.html"),
  restrict: 'E',
  bindings: {},
  controllerAs: 'vm',
  controller: AlertsMaintenancePanelController
};

function AlertsMaintenancePanelController() {
  var vm = this;
  vm.chartData = [{
    "key": "Alerts",
    "bar": true,
    "values": [],
    "color": "red"
  }];

  vm.chartOptions = {
    chart: {
      type: 'historicalBarChart',
      height: 70,
      width: 200,
      margin: {
        top: 0,
        bottom: 17,
        left: 17,
        right: 17
      },
      clipEdge: true,
      x: function (d) {
        return d[0];
      },
      y: function (d) {
        return d[1];
      },
      valueFormat: function (d) {
        return moment(d).format('HH a');
      },
      xAxis: {
        showMaxMin: true,
        tickFormat: function (d) {
          return moment(d).format('HH a');
        }
      },
      yAxis: {
        axisLabel: 'Y Axis',
        axisLabelDistance: -10,

        tickFormat: function (d) {
          return d3.format(',.0f')(d);
        }
      },
      showControls: false,
      showLegend: false,
      stacked: true,
      showYAxis: false,
      showXAxis: true,
      duration: 1,
      color: function () {
        return 'rgba(255, 0, 0, 0.5)';
      }
    }
  };

  vm.$onInit = function () {
    for (var i = 10; i > 0; i--) {
      var maintenace = Math.random() < 0.1 ? 1 : 0;
      var alert = Math.random() < 0.25 ? 1 : 0;

      var date = moment().add(-i, 'hours');
      if (alert === 1) {
        var number = Math.round(Math.random() * 5) + 1;
        vm.chartData[0].values.push([date.toDate().getTime(), number]);
      } else {
        vm.chartData[0].values.push([date.toDate().getTime(), 0]);
      }
    }
  };
}

export default AlertsMaintenanceHistoryComponent;